import { Component, Inject, Input, OnInit } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InterfaceMesurement } from 'app/models/mesurement.model';
import { DepartmentService } from 'app/services/department.service';
import { IndicatorService } from 'app/services/indicator.service';
import { timezone } from 'assets/constants/timezone';
import { Observable, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as timezoneDayJs from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezoneDayJs);

@Component({
  selector: 'app-create-mesurement',
  templateUrl: './create-mesurement.component.html',
  styleUrls: ['./create-mesurement.component.scss']
})
export class CreateMesurementComponent implements OnInit {

  indicatorForm: FormGroup;
  isSaving = false;
  startWeek: string;
  endWeek: string;
  currentWeek: number;
  currentMonth: number;
  userName: string;
  userId: string;
  currentYear: number;
  newMesurement: InterfaceMesurement;
  subscriptions: Subscription[] = [];
  currentPercentage = 0;
  isUploadingFile = false;
  downloadURL: Observable<string> = new Observable;
  isPlan = true;
  isCause = false;
  @Input() data: any;

  constructor(
    protected fb: FormBuilder,
    protected indicatorService: IndicatorService,
    protected departmentService: DepartmentService,
    protected storage: AngularFireStorage,
    public ngbActiveModal: NgbActiveModal
  ) {
  }

  ngOnInit(): void {
    this.indicatorForm = this.fb.group({
      result: [null, Validators.required],
      cause: [null, Validators.nullValidator],
      plan1: [null, Validators.nullValidator],
      datePlan1: [null, Validators.nullValidator],
      plan2: [null, Validators.nullValidator],
      datePlan2: [null, Validators.nullValidator],
      plan3: [null, Validators.nullValidator],
      datePlan3: [null, Validators.nullValidator],
      observation: [null, Validators.nullValidator],
      urlFilePlan: [null, Validators.nullValidator],
      urlFileCause: [null, Validators.nullValidator],
    });
    if (this.data.currentMesurement) {
      this.indicatorForm.patchValue(this.data.currentMesurement);
      this.indicatorForm.updateValueAndValidity();
    }
    if (this.data.mesurementType === 'monthly') {
      this.startWeek = dayjs().tz(timezone).startOf('month').format('DD/MM/YYYY');
      this.endWeek = dayjs().tz(timezone).endOf('month').format('DD/MM/YYYY');
    } else {
      this.startWeek = dayjs().tz(timezone).startOf('isoWeek').format('DD/MM/YYYY');
      this.endWeek = dayjs().tz(timezone).endOf('isoWeek').format('DD/MM/YYYY');
    }
    // this.currentMonth = Number(dayjs().tz(timezone).format('MM'));
    // this.currentWeek = dayjs().tz(timezone).isoWeek();
    this.currentMonth = this.data.currMonth;
    this.currentWeek = this.data.currWeek;
    
    console.log("Año NO modificado en el modal : ",this.currentYear)
    this.currentYear = this.data.currYear //dayjs().tz(timezone).year();
    console.log("Año modificado en el modal : ",this.currentYear)
    this.userName = localStorage.getItem('userName') || 'Not found user';
    this.userId = localStorage.getItem('userId') || 'Not found user';
  }

  close(): void {

    this.ngbActiveModal.close();
  }

  save(): void {
    this.isSaving = true;
    if (this.data.mesurementType === 'monthly') {
      this.newMesurement = {
        ...this.indicatorForm.value,
        createdAt: dayjs().tz(timezone).unix(),
        createdByName: this.userName,
        createdById: this.userId,
        history: [],
        indicatorId: this.data.indicator.id,
        id: this.indicatorService.createId(),
        yearNumber: this.currentYear,
        monthNumber: this.currentMonth
      };
    } else {
      this.newMesurement = {
        ...this.indicatorForm.value,
        createdAt: dayjs().tz(timezone).unix(),
        createdByName: this.userName,
        createdById: this.userId,
        history: [],
        indicatorId: this.data.indicator.id,
        id: this.indicatorService.createId(),
        weekNumber: this.currentWeek,
        yearNumber: this.currentYear
      };
    }
    this.indicatorService.createMesurement(this.newMesurement).then(() => {
      this.updateIndicator();
    }).catch((error: any) => {
      console.error('Error creating mesurement =>', error);
      this.ngbActiveModal.close({
        success: false,
        error
      });
    });
  }
  uploadFile(target: any, field: string, flagFile: boolean): void {
    if (flagFile) {
      this.isPlan = true;
      this.isCause = false;
    } else {
      this.isPlan = false;
      this.isCause = true;
    }
    let fileUploadSub: Subscription;
    this.isUploadingFile = true;
    this.currentPercentage = 0;
    // getting the file uploaded
    const file = target.files[0];
    // creating the path for the storage
    const filePath = `Indicators/${this.data.indicator.id}/${Date.now()}`;
    // reference to storage
    const fileRef = this.storage.ref(filePath);
    // object to upload the file
    const task = this.storage.upload(filePath, file);
    fileUploadSub = task.percentageChanges().subscribe((percentage: any) => {
      this.currentPercentage = percentage;
    }, (error: any) => {
      console.error(error);
    });
    // checking status of the upload
    this.subscriptions.push(
      task.snapshotChanges().pipe(
        finalize(() => {
          this.downloadURL = fileRef.getDownloadURL();
          this.subscriptions.push(
            // getting the url to download
            this.downloadURL.subscribe(url => {
              if (url) {
                fileUploadSub.unsubscribe();
                this.indicatorForm.controls[field].patchValue(url);
                this.indicatorForm.controls[field].updateValueAndValidity();
                this.isUploadingFile = false;
                this.isPlan = false;
                this.isCause = false;
              }
            }, (error: any) => {
              console.error(error);
            })
          );
        })
      ).subscribe((subscribeResult: any) => {
        console.log(subscribeResult);
      }, (error: any) => {
        console.error(error);
      })
    );
  }

  updateIndicator(): void {
    if (this.data.mesurementType === 'monthly') {
      if (this.data.indicator.montlyResults) {
        this.data.indicator.montlyResults[`${this.currentYear}-${this.currentWeek}`] = this.newMesurement.result;
      } else {
        this.data.indicator.montlyResults = {};
        this.data.indicator.montlyResults[`${this.currentYear}-${this.currentWeek}`] = this.newMesurement.result;
      }
    } else {
      if (this.data.indicator.results) {
        this.data.indicator.results[`${this.currentYear}-${this.currentWeek}`] = this.newMesurement.result;
      } else {
        this.data.indicator.results = {};
        this.data.indicator.results[`${this.currentYear}-${this.currentWeek}`] = this.newMesurement.result;
      }
    }
    this.departmentService.updateIndicator(this.data.indicator).then(() => {
      this.ngbActiveModal.close({
        success: true,
        mesurement: this.newMesurement
      });
    }).catch((error: any) => {
      console.error('Error updating indicator =>', error);
      this.ngbActiveModal.close({
        success: false,
        error
      });
    });
  }
}
